import React, { ReactNode } from 'react';
import { storyblokInit, apiPlugin } from '@storyblok/react';
import { richTextComponentMapping } from '@repo/roche-xx-shared';

// Initialize the Storyblok SDK
storyblokInit({
  accessToken: process.env.GATSBY_STORYBLOK_SPACE_API_KEY,
  use: [apiPlugin],
  components: richTextComponentMapping,
});

interface StoryblokProviderProps {
  children: ReactNode;
}

export const StoryblokProvider: React.FC<StoryblokProviderProps> = ({ children }) => {
  return <>{children}</>;
};
